import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../app/mainReducer";

export function useIsAuth() {
  const navigate = useNavigate();
  const isLogged = useSelector((state: RootState) => !!state.sistema.token);

  useEffect(() => {
    if (!isLogged) {
      navigate("/login");
      return;
    }
  }, [isLogged, navigate]);
}
